import { setSpinnerLoading } from "../utility/Redux/modal";
import { CallAPIPromise } from "../billing/common";

const checkLastPurchasePrice = (
  prefix,
  partyName,
  icode,
  price,
  token,
  dispatch,
  isLastPurIgnore
) => {
  const data = {
    table_prefix: prefix,
    NAME: partyName,
    ICODE: icode,
  };
  return new Promise((resolve, reject) => {
    if (isLastPurIgnore) {
      resolve();
    }
    if (!isLastPurIgnore) {
      dispatch(setSpinnerLoading("Last Purchase Price"));

      CallAPIPromise(`/api/purchaseBillUtils/lastPurchasePrice`, data, token)
        .then((res) => {
          if (!res.data.error) {
            const data = res.data.response;
            resolve(data);
          } else {
            reject(new Error("Error in response data"));
          }
        })
        .catch((e) => {
          reject(e);
        })
        .finally(() => {
          dispatch(setSpinnerLoading(false));
        });
    }
  });
};

export default checkLastPurchasePrice;
